import React from 'react'

const RegionCardHeader = ({
  className = "",
  /** Deprecated */
  classNames = "",
  titleClasses = "",
  chidrenWrapperClassName = "",
  title = "",
  children = () => null,
  hasButtons = false
}) => {
  const childrenArray = React.Children.toArray(children);
  return (
    <div className={`card-header ${classNames ? classNames : ""} ${className ? className : ""} ${hasButtons ? "pt-0" : ""}`}>
      <h2 className={`card-title-lg ${titleClasses ? titleClasses : ""} ${hasButtons ? "card-padding-top" : ""}`}>
        {title}
      </h2>
      {!!childrenArray.length && <div className={`${hasButtons ? "" : "card-padding-left card-padding-right"} ${chidrenWrapperClassName ? chidrenWrapperClassName : ""}`}>
        {children}
      </div>}
    </div>
  );
}

export default RegionCardHeader;